import React from 'react';
import PropTypes from 'prop-types';
import CommonEditIconButton from '../../../common/components/CommonEditIconButton';
import CommonDeleteIconButton from '../../../common/components/CommonDeleteIconButton';

function SearchAlertsTableRow({ item, setSearchAlertToDelete, editItemHandler }) {
  return (
    <>
      <td className="font-weight-bold">{item?.vehicleMakeName || 'All Makes'}</td>
      <td className="font-weight-bold">{item?.vehicleModelName || 'All Models'}</td>
      <td>
        {!item?.yearFrom && !item?.yearTo
          ? 'All'
          : `${item?.yearFrom || 'Any'} - ${item?.yearTo || 'Any'}`}
      </td>
      <td>
        {item?.mileageMaxValue
          ? `Up to ${item?.mileageMaxValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} miles`
          : 'All'}
      </td>
      <td className="common-table__action-cell">
        <CommonEditIconButton
          className="employees-table-row__action-button employees-table-dark-button"
          handleClick={() => editItemHandler(item.id)}
        />
        <CommonDeleteIconButton
          className="employees-table-row__action-button employees-table-red-button"
          handleClick={() => setSearchAlertToDelete(item.id)}
        />
      </td>
    </>
  );
}

SearchAlertsTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default SearchAlertsTableRow;
